import type { FC } from 'react';
import { useSelector } from 'react-redux';

import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';

import PaymentStatusInterstate from '../../common/PaymentStatus.interstate';
import { DrawerHeader } from './DrawerHeader';
import { InventoryTypeSelect } from './InventoryTypeSelect';
import { NoVehicleActions } from './NoVehicleActions';
import PricingForm from './PricingForm';
import { DrawerContent, NoVehicleHeader } from './Style';
import { VehicleImage } from './VehicleImage';
import { VehicleInfo } from './VehicleInfo';
import { VehicleNotes } from './VehicleNotes';

export const ContentForm: FC = () => {
    const { condition, imageUrl, inventoryDate, location, make, model, notes, stockNumber, trim, vin, year } = useSelector(
        vehicleSelectors.getVehicle
    );
    const hasVehicle = useSelector(vehicleSelectors.getHasVehicle);
    const isQuickQuoteEnabled = useSelector(featureToggleSelectors.isManagerViewQuoteModeEnabled);
    // For a deal/quote without a vehicle, replace the vehicle-title header (title/VIN/Stock#) with the
    // Inventory Type dropdown + Add Vehicle / vAuto links (US2032152). The remaining vehicle-detail and
    // pricing fields are kept. Once a vehicle is added, the flyout returns to its regular header.
    const showInventoryType = isQuickQuoteEnabled && !hasVehicle;

    return (
        <DrawerContent>
            <PaymentStatusInterstate />
            {showInventoryType ? (
                <NoVehicleHeader>
                    <InventoryTypeSelect />
                    <NoVehicleActions />
                </NoVehicleHeader>
            ) : (
                <DrawerHeader {...{ condition, inventoryDate, year, model, make, trim, vin, stockNumber }} />
            )}
            <VehicleInfo location={location} />
            <PricingForm />
            <VehicleImage imageUrl={imageUrl} />
            <VehicleNotes notes={notes} />
        </DrawerContent>
    );
};
